module.exports = __webpack_public_path__ + "static/media/legal-services.7483ef9a.svg";